'use client';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components';
import { useProductValue } from '@/context';
import { PATHNAME } from '@/utils';

const {
  DEFAULT: { SLUG_SEPARATOR: DEFAULT_SLUG_SEPARATOR },
  LOCAL: {
    HOME: { BASE_URL: HOME_PAGE_BASE_URL },
    CATEGORY: { BASE_URL: CATEGORY_BASE_URL },
  },
} = PATHNAME;

const ProductBreadcrumbs = () => {
  const { mainCategory, name } = useProductValue();

  return (
    <Breadcrumb className='container my-4'>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink href={HOME_PAGE_BASE_URL}>کاشی لند</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          {mainCategory ? (
            <BreadcrumbLink
              href={`${CATEGORY_BASE_URL}${mainCategory.slug}${DEFAULT_SLUG_SEPARATOR}`}
            >
              {mainCategory.title}
            </BreadcrumbLink>
          ) : null}
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage>{name}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export { ProductBreadcrumbs };
